<template>
    <v-col cols="12" md6 offset-md="0" class="pa-0">
        <span>Настройки подключения Telegram</span>
        <v-divider ></v-divider>
        <v-col cols="12" md6 offset-md="0" class="pa-0">
            <v-checkbox class="pa-0 ma-1 mx-2"
                        v-model="botModel.token_tg"
                        label="Подключение бота к Telegram"
                        readonly
                        :color="botModel.token_tg == '1' ? 'success' : 'error'"
                        true-value="1"
                        false-value="0"
                        success-text="false"
                        hide-details
                        title="Для подключения бота, напишите token и нажмите кнопку сохранить"
            ></v-checkbox>
        </v-col>
        <v-col cols="12" md6 offset-md="0" class="pa-0 my-3">
            <v-text-field class="pa-0 ma-1 mx-2"
                        v-model="botModel.token_tg"
                        label="Токен для Telegram"
                        hide-details
                        :value="token_tg"
            ></v-text-field>
        </v-col>
        <v-col
                v-for="(command, index) in commands"
                cols="11" md6 offset-md="0" class="pa-0 my-3">
            <v-row>
                <v-text-field class="pa-0 ma-1 mx-2"
                              v-model="command['command']"
                              :label="'Команда ' + (index + 1) + ' Латинскими прописными буквами'"
                              :value="command['command']"
                              :counter="32"
                ></v-text-field>
                <v-text-field class="pa-0 ma-1 mx-2"
                              v-model="command['description']"
                              :label="'Описание ' + (index + 1) + ' Не менее 3 символов'"
                              :counter="256"
                              :value="command['description']"
                ></v-text-field>
                <v-btn icon small title="Удалить команду" @click="removeCommand(index)"><v-icon small>remove</v-icon></v-btn>
            </v-row>
        </v-col>
        <v-col cols="12" md6 offset-md="0" class="pa-0 my-3" v-show="token_tg === '1'">
            <v-btn small @click="addCommand">Добавить команду</v-btn>
        </v-col>
        <v-col cols="12" md6 offset-md="0" class="pa-0 my-3" v-show="token_tg !== '' && token_tg !== '0'">
            <v-btn small @click="setMyCommands">Сохранить команды</v-btn><br/>
            <p class="red--text">{{errorText}}</p>
        </v-col>
        <v-snackbar
                v-model="snackbarParams.show"
                bottom
                :color="snackbarParams.color"
                right
        >
            {{snackbarParams.text}}
            <v-btn
                    dark
                    text
                    @click="snackbar = false"
            >
                Закрыть
            </v-btn>
        </v-snackbar>
    </v-col>
</template>

<script>
import axios from 'axios'
import constConf from '../../../constconf'
export default {
    name: 'BotFormConnectTg',
    components: {
    },
    data() {
        return {
            visSelectGroupVkDialog: false,
            visSettingGroupVkDialog: false,
            mailingParam: true,
            commands: [],
            snackbarParams: {
                show: false,
                text: 'Успешно сохранено',
                color: 'success'
            },
            errorText: ''
        }
    },
    props: ['botModel'],
    computed: {
        token_tg() {
            // console.log(this.botModel.token_tg)
            return this.botModel.token_tg !== '1' ? '' : this.botModel.token_tg
        }
    },
    methods: {
        showSelectGroupDialog(mailingParam) {
            this.mailingParam = mailingParam
            this.visSelectGroupVkDialog = true
        },
        getMyCommands() {
            if (this.botModel.id !== null && this.botModel.token_tg !== '0') {
                axios.defaults.withCredentials = true
                axios.post(constConf.bot.url + '/bot/get-my-commands/' + this.botModel.id).then(response => {
                    this.snackbarParams.color = response.data.ok ? 'success' : 'error'
                    this.snackbarParams.text = response.data.response.text
                    this.snackbarParams.show = true
                    this.commands = response.data.response.data
                    // eslint-disable-next-line handle-callback-err
                }).catch((error) => {
                    console.log('error query api' + error)
                })
            }
        },
        addCommand() {
            this.commands.push({ command: '', description: '' })
        },
        removeCommand(index) {
            this.commands.splice(index, 1)
        },
        setMyCommands() {
            let commandsError = []
            let commandsToSave = []
            for (let i = 0; i < this.commands.length; i++) {
                if (this.commands[i].command.length === 0 ||
                    this.commands[i].command.length > 35 ||
                    this.commands[i].description < 4 ||
                    this.commands[i].description > 256
                ) {
                    commandsError.push(i)
                } else {
                    commandsToSave.push(this.commands[i])
                }
            }
            if (commandsError.length > 0) {
                this.errorText = 'Команды ' + commandsError.join(', ') + ' требуют правок'
                setTimeout(() => { console.log(this.errorText = '') }, 2000)
            }
            axios.defaults.withCredentials = true
            axios.post(constConf.bot.url + '/bot/set-my-commands/' + this.botModel.id, commandsToSave).then(response => {
                this.snackbarParams.color = response.data.ok ? 'success' : 'error'
                this.snackbarParams.text = response.data.response.text
                this.snackbarParams.show = true
                // this.commands = response.data.response.data
                // eslint-disable-next-line handle-callback-err
            }).catch((error) => {
                console.log('error query api' + error)
            })
        }
    },
    watch: {
        botModel: {
            handler() {
                if (this.botModel.hasOwnProperty('id')) {
                    this.getMyCommands()
                }
            },
            deep: true,
            immediate: true
        }
    }
}
</script>

<style scoped>
    .v-text-field {
        font-size: 0.9em;
    }
</style>
